import { PreferenceOverrideSourceEnum } from '../../types';
export var PreferenceLevelEnum;
(function (PreferenceLevelEnum) {
    PreferenceLevelEnum["GLOBAL"] = "global";
    PreferenceLevelEnum["TEMPLATE"] = "template";
})(PreferenceLevelEnum || (PreferenceLevelEnum = {}));
//# sourceMappingURL=subscriber-preference.interface.js.map